import { useQuery } from 'react-query';
import { useClient } from '../../../../api/api-client';

export function useGetAddressDetails(orderId, queryConfig = {}) {
  const client = useClient();

  return useQuery({
    queryKey: ['order_serviceability', orderId],
    queryFn: () =>
      client(`lifeline_apis/user/order_serviceability?order_id=${orderId}`),
    ...queryConfig,
  });
}

export function useGetServeciableStores(queryParams = {}, queryConfig = {}) {
  const client = useClient();

  return useQuery({
    queryKey: ['check_serviceable_store', queryParams],
    queryFn: () =>
      client(
        `lifeline_apis/user/check_serviceable_store?order_id=${queryParams.orderId}&lat=${queryParams.cxLat}&lng=${queryParams.cxLng}`,
      ),
    ...queryConfig,
  });
}

export const updateCustomerLocationEndpoint =
  'lifeline_apis/user/update_drop_address';
